module.exports = __webpack_public_path__ + "static/media/whatsapp.5368469c.svg";